import { render, staticRenderFns } from "./PopupListDoctor.vue?vue&type=template&id=8f7204dc&scoped=true&"
import script from "./PopupListDoctor.vue?vue&type=script&lang=ts&"
export * from "./PopupListDoctor.vue?vue&type=script&lang=ts&"
import style0 from "./PopupListDoctor.vue?vue&type=style&index=0&id=8f7204dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7204dc",
  null
  
)

export default component.exports